module.exports = __webpack_public_path__ + "static/media/starmarket.78def9e0.svg";